/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addToCartEcom } from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import { getCurrentCurrency } from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import {
  getAPIConfigForAdobe,
  getSessionDataForAdobe,
  getUserState,
} from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { PLPLabels } from '@tcp/core/src/utils/labels/browse/PLP.labels';
import HorizontalCategoryView from '../views/HorizontalCategory.view';
import {
  getNavigationData,
  getHorizontalPlpProducts,
  getNumberofSubcategoryFetched,
  getHlpCurrentCid,
  getHorizontalPlpProductsSeoData,
  getIsInitialCall,
  getInitialHplpValues,
  getIsHorizontalPlpLoading,
} from './HorizontalCategory.selectors';
import {
  getCurrentNavIds,
  getDefaultStore,
  getCategoryId,
  getCurrentNavId,
  getIsLayoutFetched,
  getIsPromoCallCompletedForCategory,
  getIsPromoCombinationHasTopPromos,
  getIsHidePlpGridAndFilters,
} from '../../CategoryListingPage/container/CategoryListingPage.selectors';
import { getMoreHorizontalCategory, setIsHplp } from './HorizontalCategory.actions';
import { setPlpProductData } from '../../ProductDetail/container/ProductDetail.actions';
import { setPlpDataForQuickView } from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { getBrandInCaps } from '../../../../../utils';
import { HEADER_LONGER_BRAND_IDS } from '../../../../../constants/brandSpecific.constants';
import {
  getIsPLPCarouselEnabled,
  getAbTestIsTopRatedBadgeEnabled,
  getAbTestIsBestSellerBackAbTestEnabled,
  getIsNewSwatchURLEnabled,
  isShopThisStoreModeOn,
  getIsATBIconEnabled,
  getIsNewNavigationImagesEnabled,
  getIsNewSBCImplementationEnabled,
  getIsOneClickATCEnabled,
  getIsHideOriginalPriceAndMarchantTagEnabled,
  getIsHplpCmsSbcEnabled,
  getIsGenericSBCRedesignEnabled,
  getIsInfluencerBadgeEnabledForListingPages,
  getisRatingRedesignAbTest,
  getIsHplpFiltersEnabled,
  getTileRedesignAB,
  getSeoHeaderAlignTopEnabled,
  getSortByRatingLabel,
  getHorizontalCarouselPLPCatIds,
  getOutfitCarouselPillCategories,
  getIsOutfitCarouselPillEnabled,
  getOutfitCarouselPillCategoriesAB,
  getIsPillVariationEnabledOnAllPlps,
} from '../../../../../reduxStore/selectors/session.selectors';
import { setClickAnalyticsData, trackClick, trackPageView } from '../../../../../analytics/actions';
import useHlpAnalytics from './hooks/useHlpAnalytics';
import { getFavoriteStore } from '../../../account/User/container/User.selectors';

const HorizontalCategoryContainer = (props) => {
  const plpTileLabels = getLabelFromCopyOrFromTranslation('PLP.plpTiles', PLPLabels);

  const pickupInStore = renderLabel(
    plpTileLabels.lbl_plp_pickup_in_store,
    'lbl_plp_pickup_in_store'
  );
  const addToBag = renderLabel(plpTileLabels.lbl_add_to_bag, 'lbl_add_to_bag');
  const brandId = HEADER_LONGER_BRAND_IDS[getBrandInCaps()];
  const { shopThisStoreAnalyticFlag } = props;
  const renderAddToBagLabel = () => {
    if (isShopThisStoreModeOn()) {
      return pickupInStore;
    }
    return addToBag;
  };
  if (!shopThisStoreAnalyticFlag) {
    useHlpAnalytics(props);
  }
  return (
    <HorizontalCategoryView {...props} submitButtonText={renderAddToBagLabel()} brandId={brandId} />
  );
};

const mapStateToProps = (state) => {
  return {
    navigationData: getNavigationData(state),
    horizontalPlpProducts: getHorizontalPlpProducts(state),
    currentNavIds: getCurrentNavIds(state),
    subCategoryFetched: getNumberofSubcategoryFetched(state),
    currentCid: getHlpCurrentCid(state),
    currency: getCurrentCurrency(state),
    isTopRatedBackAbEnabled: getAbTestIsTopRatedBadgeEnabled(state),
    isBestSellerBackAbEnabled: getAbTestIsBestSellerBackAbTestEnabled(state),
    isPLPCarouselEnabled: getIsPLPCarouselEnabled(state),
    isNewSwatchUrlEnabled: getIsNewSwatchURLEnabled(state),
    addToBagIconInPLP: getIsATBIconEnabled(state),
    isNewNavigationImagesEnabled: getIsNewNavigationImagesEnabled(state),
    storeId: getFavoriteStore(state),
    defaultStoreId: getDefaultStore(state),
    horizontalPlpProductsSeoData: getHorizontalPlpProductsSeoData(state),
    isNewSBCImplementationEnabled: getIsNewSBCImplementationEnabled(state),
    isOneClickATCEnabled: getIsOneClickATCEnabled(state),
    isHideOriginalPriceAndMarchantTagEnabled: getIsHideOriginalPriceAndMarchantTagEnabled(state),
    isHplpCmsSbcEnabled: getIsHplpCmsSbcEnabled(state),
    isGenericSBCRedesignEnabled: getIsGenericSBCRedesignEnabled(state),
    isInfluencerBadgeEnabled: getIsInfluencerBadgeEnabledForListingPages(state),
    isInitialCall: getIsInitialCall(state),
    isRatingRedesignAbTest: getisRatingRedesignAbTest(state),
    isTileRedesignAB: getTileRedesignAB(state),
    initialValues: getInitialHplpValues(state),
    isHplpFiltersEnabled: getIsHplpFiltersEnabled(state),
    isLoading: getIsHorizontalPlpLoading(state),
    User: getUserState(state),
    APIConfig: getAPIConfigForAdobe(state),
    session: getSessionDataForAdobe(state),
    categoryId: getCategoryId(state),
    currentNavId: getCurrentNavId(state),
    isSeoHeaderAlignTopEnabled: getSeoHeaderAlignTopEnabled(state),
    sortByRatingLabel: getSortByRatingLabel(state),
    HPLPCategories: getHorizontalCarouselPLPCatIds(state),
    outfitCarouselPillCategories: getOutfitCarouselPillCategories(state),
    layoutFetched: getIsLayoutFetched(state),
    isOutfitCarouselPillDesignEnabled: getIsOutfitCarouselPillEnabled(state),
    outfitCarouselPillCategoriesAB: getOutfitCarouselPillCategoriesAB(state),
    isPromoCallCompleted: getIsPromoCallCompletedForCategory(state),
    hasTopPromos: getIsPromoCombinationHasTopPromos(state),
    isOutfitPillVariationEnabledOnAllPlps: getIsPillVariationEnabledOnAllPlps(state),
    hidePlpGridAndFilters: getIsHidePlpGridAndFilters(state),
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getMoreHorizontalCategoryActn: (payload) => {
      dispatch(getMoreHorizontalCategory(payload));
    },
    addToBagEcom: (payload) => {
      dispatch(addToCartEcom(payload));
    },
    saveProductDataForPdp: (payload) => {
      dispatch(setPlpProductData(payload));
    },
    saveProductDataForQV: (payload) => {
      dispatch(setPlpDataForQuickView(payload));
    },
    trackPageLoad: (payload) => {
      const {
        products,
        customEvents,
        departmentList,
        categoryList,
        listingSubCategory,
        pageSearchText,
        listingCount,
        pageSearchType,
        internalCampaignId,
        supressProps,
        storeId,
        promoFilterCategoryTrail,
        pageNavigationText,
        ...others
      } = payload;
      if (payload.pageType === 'search') {
        const { trackPageLoadSearchRedirect } = ownProps;
        trackPageLoadSearchRedirect(payload);
      }
      dispatch(
        setClickAnalyticsData({
          products,
          customEvents,
          departmentList,
          categoryList,
          listingSubCategory,
          pageSearchText,
          listingCount,
          pageSearchType,
          internalCampaignId,
          supressProps,
          storeId,
          promoFilterCategoryTrail,
          pageNavigationText,
        })
      );
      const timer = setTimeout(() => {
        dispatch(
          trackPageView({
            props: {
              initialProps: {
                pageProps: {
                  pageData: {
                    ...others,
                  },
                },
              },
            },
          })
        );
        const analyticsTimer = setTimeout(() => {
          dispatch(setClickAnalyticsData({}));
          clearTimeout(analyticsTimer);
        }, 200);
        clearTimeout(timer);
      }, 100);
    },
    trackHorizontalPlpAnalytic: (payload) => {
      const timer = setTimeout(() => {
        dispatch(setClickAnalyticsData(payload));
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 200);
    },
    setIsHplpPage: (payload) => {
      dispatch(setIsHplp(payload));
    },
  };
};
HorizontalCategoryContainer.propTypes = {
  isTopRatedBackAbEnabled: PropTypes.bool,
  isBestSellerBackAbEnabled: PropTypes.bool,
  addToBagIconInPLP: PropTypes.bool,
  isOneClickATCEnabled: PropTypes.bool,
  addToBagEcom: PropTypes.func,
  currency: PropTypes.string,
  trackPageLoadSearchRedirect: PropTypes.func,
  User: PropTypes.shape({}),
  APIConfig: PropTypes.shape({}),
  session: PropTypes.shape({}),
  shouldRenderSkeletonComponent: PropTypes.bool,
};
HorizontalCategoryContainer.defaultProps = {
  isTopRatedBackAbEnabled: false,
  isBestSellerBackAbEnabled: false,
  addToBagIconInPLP: false,
  isOneClickATCEnabled: false,
  addToBagEcom: () => {},
  currency: 'USD',
  trackPageLoadSearchRedirect: () => {},
  User: {},
  APIConfig: {},
  session: {},
  shouldRenderSkeletonComponent: false,
};
export default connect(mapStateToProps, mapDispatchToProps)(HorizontalCategoryContainer);
